// Featured-Collection: beim Verlassen wieder auf erstes Bild springen
document.addEventListener('pointerleave', (ev) => {
  const gallery = ev.target.closest('#shopify-section-template--26463301108042__product_list_fa6P9H .card-gallery');
  if (!gallery) return;

  // 1) Falls das Slideshow-Component eine goTo-Methode hat, nutze sie
  const slideshow = gallery.querySelector('slideshow-component');
  if (slideshow && typeof slideshow.goTo === 'function') {
    try { slideshow.goTo(0); } catch(e) {}
  }

  // 2) Fallback: den Scroller ganz nach links setzen
  const scroller = gallery.querySelector('slideshow-slides, [ref="scroller"]');
  if (scroller) {
    scroller.scrollLeft = 0;
  }

  // manche Themes „merken“ sich den Status über ein Attribut
  if (slideshow) slideshow.removeAttribute('actioned');
});

// Sicherheitshalber auch auf mouseleave (ältere Browser)
document.addEventListener('mouseleave', (ev) => {
  const gallery = ev.target.closest('#shopify-section-template--26463301108042__product_list_fa6P9H .card-gallery');
  if (!gallery) return;
  const scroller = gallery.querySelector('slideshow-slides, [ref="scroller"]');
  if (scroller) scroller.scrollLeft = 0;
});
